import type { GeofenceFormAction } from './actions';
import { ActionTypes } from './actionTypes';

import type { Geofence } from '@cobliteam/common-types';

import {
  type WebData,
  webDataFetching,
  webDataNotAsked,
  webDataSuccess,
} from '@cobliteam/api-lib';

import { rootReducer } from '../HOR';

export interface GeofenceFormState {
  geofenceWebData: WebData<Geofence>;
}

export const geofenceFormInitialState: GeofenceFormState = {
  geofenceWebData: webDataNotAsked(),
};

const formReducer = (
  state: GeofenceFormState = geofenceFormInitialState,
  action: GeofenceFormAction
): GeofenceFormState => {
  if (!(action.type in ActionTypes)) {
    return state;
  }

  switch (action.type) {
    case ActionTypes.CHANGE_GEOFENCE_ADDRESS_REQUEST:
      return {
        ...state,
        geofenceWebData: webDataFetching(),
      };

    case ActionTypes.CHANGE_GEOFENCE_ADDRESS_SUCCEEDED:
      return {
        ...state,
        geofenceWebData: webDataSuccess(action.payload),
      };

    case ActionTypes.CHANGE_GEOFENCE_COORDINATE_REQUEST:
      return {
        ...state,
        geofenceWebData: webDataFetching(),
      };

    case ActionTypes.CHANGE_GEOFENCE_COORDINATE_SUCCEEDED:
      return {
        ...state,
        geofenceWebData: webDataSuccess(action.payload),
      };

    case ActionTypes.CLEAR_GEOFENCE:
      return {
        ...state,
        geofenceWebData: webDataNotAsked(),
      };

    default:
      return state;
  }
};

export const geofenceFormReducer = rootReducer(
  [formReducer],
  geofenceFormInitialState
);
